import styled from 'styled-components'
import { IndexLayoutOldTitle } from '@sketch/modules-common'

import { breakpoint } from '@sketch/global-styles'
import { Heading } from '@sketch/components'

export const DetailsBreadcrumbsContainer = styled.div`
  display: none;

  ${breakpoint('sm')`
    display: block;

    text-align: center;
    margin-top: 12px;

    + ${IndexLayoutOldTitle} {
      margin-top: 32px;
    }
  `}
`
export const PaymentBreadcrumbsContainer = styled(DetailsBreadcrumbsContainer)`
  display: none;

  ${breakpoint('sm')`
    display: block;
    text-align: center;
    margin-top: 35px;
  `}

  /* Fix the payment step title margin that shows an extra spacing that's unwanted */
  & + ${Heading.H1} {
    margin-top: 0px;
  }
`

export const WorkspaceDetailsWrapper = styled.div`
  max-width: 500px;
  width: 100%;
  margin: 32px auto 0;
`
